import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'

import Button from '../../../../components/button'
import Input from '../../../../components/form-fields/input'
import { FORM_MESSAGES } from '../../../../constants'
import { labels } from '../../constants'
import styles from '../modal-add-content-to-lists.css'

const CreateListScreen = ({
  creating,
  onCreateList
}) => {
  const {
    control,
    handleSubmit,
    setFocus,
    formState: { errors }
  } = useForm({
    defaultValues: {
      watchlistName: ''
    }
  })

  useEffect(() => {
    setFocus('watchlistName')
  }, [setFocus])

  const handleCreateList = ({ watchlistName }) => {
    onCreateList(watchlistName)
  }

  return (
    <form onSubmit={handleSubmit(handleCreateList)}>
      <Controller
        name="watchlistName"
        control={control}
        rules={{
          required: FORM_MESSAGES.required,
          validate: value => {
            return value.trim().length > 0 || 'Please enter a valid list name'
          }
        }}
        render={({ field }) => (
          <Input
            label={labels.listNameInputLabel}
            {...field}
            error={errors[field.name]?.message}
            autoComplete="off"
            autoFocus
          />
        )}
      />
      <Button
        className={styles.doneButton}
        disabled={creating}
        text={labels.createButton}
      />
    </form>
  )
}

CreateListScreen.propTypes = {
  creating: PropTypes.bool.isRequired,
  onCreateList: PropTypes.func.isRequired
}

export default CreateListScreen
